import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'details-element-polyfill'
import { initializeFpid } from '@ampdx/common-utils/src/fpid/index'
initializeFpid(() => true)

const PUBLIC_PATH_KEY = 'BREMICROSITEMONOREPOPATH'

__webpack_public_path__ =
  PUBLIC_PATH_KEY in window
    ? window[PUBLIC_PATH_KEY]
    : '/webfiles/latest/assets/amp-monorepo-microsites/' // eslint-disable-line
